import { GAME_ASSET_SLUG } from "@/config/game";
import { cn } from "@/lib/utils";
import { DetailedPlayer } from "@repo/shared/types";

/**
 * A single 26×26 playstyle icon in one of three states. URL pattern matches
 * production (`pages/DetailedPlayer/sections/PlayStyles/Shared.tsx`); not-owned
 * icons are dimmed + desaturated per the handoff.
 */
export const PlayStyleIcon = ({
  id,
  hasPlus,
  hasNormal,
  className,
}: {
  id: number;
  hasPlus: boolean;
  hasNormal: boolean;
  className?: string;
}) => {
  const assetsBaseUrl = import.meta.env.VITE_APP_ASSETS_BASE_URL;
  const owned = hasPlus || hasNormal;
  const src = hasPlus
    ? `${assetsBaseUrl}/${GAME_ASSET_SLUG}/playstylesplus/${id}.png`
    : `${assetsBaseUrl}/${GAME_ASSET_SLUG}/playstyles/${id}.png`;
  return (
    <img
      src={src}
      alt={`PlayStyle ${id}`}
      className={cn(
        "size-[26px] object-contain",
        !owned && "opacity-25 grayscale",
        className,
      )}
    />
  );
};
